import { render, staticRenderFns } from "./MainNavDrawer.vue?vue&type=template&id=22b842cc&scoped=true"
import script from "./MainNavDrawer.vue?vue&type=script&lang=ts"
export * from "./MainNavDrawer.vue?vue&type=script&lang=ts"
import style0 from "./MainNavDrawer.vue?vue&type=style&index=0&id=22b842cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b842cc",
  null
  
)

export default component.exports